/**
 * Real API implementation for User list (Invite Users page).
 * GET /api/v3/users – list users with pagination (org from auth token).
 */

import { apiClient } from '../apiClient';
import { normalizePaginatedResponse } from '../utils/paginationResponseUtils';

const V3_USERS_PATH = '/api/v3/users';
const DEFAULT_PAGE_SIZE = 10;
const MAX_PAGE_SIZE = 50;

/**
 * GET /api/v3/users – list users (org from auth token). Used by Invite Users page.
 *
 * @param {string} organizationId - Ignored by v3 (org from token); kept for API compatibility.
 * @param {Object} params - { limit (maps to page_size), cursor (page number), search, signal }
 * @returns {Promise<{ data: Array, pagination: { nextCursor, totalCount } }>}
 */
export const getUsersByOrganizationPaginated = async (organizationId, params = {}) => {
  const { limit = DEFAULT_PAGE_SIZE, cursor, search = '', signal } = params;
  const page = cursor != null && cursor !== '' ? Math.max(1, Number(cursor)) : 1;
  const pageSize = Math.min(Math.max(Number(limit) || DEFAULT_PAGE_SIZE, 1), MAX_PAGE_SIZE);
  const requestParams = { page, page_size: pageSize };
  if (search) requestParams.search = search;

  const response = await apiClient.get(V3_USERS_PATH, {
    params: requestParams,
    signal,
  });
  const raw = response?.data ?? response;
  return normalizePaginatedResponse(raw, { pageSize });
};
